import { VoiceTargetRow } from "../../settings/VoiceTargetRow";
import { VoiceRow } from "../../settings/VoiceRow";
import { ToneSelect } from "../../settings/ToneSelect";

const TONE_SPEED = { upbeat: 1.12, energetic: 1.2, calm: 1.02 };

// شبكة اختيار الأصوات + النبرة + السرعة (منفصلة لإبقاء اللوحة صغيرة).
export const VoicePicker = ({ voices, form, setForm, target, setTarget, lang, sampleName }) => {
  const labelOf = (id) => voices.find((v) => v.id === id)?.name || id;

  return (
    <>
      <VoiceTargetRow
        form={form}
        labelOf={labelOf}
        target={target}
        setTarget={setTarget}
        onSpeed={(speed) => setForm((f) => ({ ...f, speed }))}
      />
      <ToneSelect
        value={form.tone}
        onChange={(tone) => setForm((f) => ({ ...f, tone, speed: TONE_SPEED[tone] }))}
      />
      <div className="mt-3 grid gap-2 sm:grid-cols-2">
        {voices.map((voice) => (
          <VoiceRow
            key={voice.id}
            voice={voice.id}
            label={voice.name}
            lang={lang}
            name={sampleName}
            speed={Number(form.speed)}
            tone={form.tone}
            selected={form[target] === voice.id}
            onSelect={(v) => setForm((f) => ({ ...f, [target]: v }))}
          />
        ))}
      </div>
    </>
  );
};
